// extracted by mini-css-extract-plugin
export default {"magazineRow":"styles_magazineRow__7EgCf","noButtons":"styles_noButtons__0LwXb","clickable":"styles_clickable__e5FsF"};